import React, { useState } from "react";
import { Button, Form, Modal, Tooltip } from "antd";
import { useSelector } from "react-redux";

function FooterButtons({ onError, openSmodal, onFinish, form, label, type, disabled, confirmationPopUp, setSelectedButton, button, openPopupModal, postSubmitAction, downloadDocs, openAndonModal, saveForm }) {
    const apiLoading = useSelector(state => state.apiLoading);
    const [buttonData, setButtonData] = useState({
        label,
        css: {
            display: "flex",
            justifyContent: "center",
            marginBottom: 0,
            textAlign: "center",
        }
    });
    const [tooltip, setTooltip] = useState({
        visible: false,
        message: ''
    });

    const onOk = () => {
        if (button?.buttonProp.submitFormData) {
            if (form) {
                if (saveForm && !button?.buttonProp.validateFields) {
                    return saveForm({ button });
                }
                return form.submit();
            };
            if (onFinish) {
                return onFinish({ button });
            }
        };
        if (button?.buttonProp.postSubmitAction) {
            return postSubmitAction({ button });
        }
    }

    const onButtonClick = () => {
        if (setSelectedButton) {
            setSelectedButton(button);
        };
        if (button?.buttonProp?.fileDownload) {
            return downloadDocs(button)
        }
        if (confirmationPopUp) {
            Modal.confirm({
                title: confirmationPopUp["text"],
                okText: confirmationPopUp["okButtonLabel"],
                cancelText: confirmationPopUp["cancelButtonLabel"],
                cancelButtonProps: { danger: true, type: 'primary' },
                // okButtonProps: {  },
                onOk
            });
        } else {
            if (button?.buttonProp?.submitFormData) {
                if (saveForm && !button?.buttonProp.validateFields) {
                    return saveForm({ button });
                }
                if (form) {
                    return form.submit();
                }
                if (onFinish) {
                    return onFinish({ button });
                }
            };
            if (button?.buttonProp?.smodal) {
                return openSmodal(button);
            }
            if (button?.buttonProp?.popUpModal) {
                return openPopupModal(button);
            };
            if (button?.buttonProp?.postSubmitAction) {
                return postSubmitAction({ button })
            };
        }
    }

    const onClickHandler = () => {
        if (label === 'Andon') {
            return openAndonModal();
        };
        if (button?.buttonProp?.resetFields) {
            return form.resetFields();
        }
        if (button?.buttonProp?.validateFields) {
            form
                .validateFields()
                .then(() => {
                    onButtonClick();
                })
                .catch((errors) => {
                    if (onError) {
                        return onError(errors);
                    }
                    console.log(errors);
                    let inputFieldName = "ReportForm_" + errors.errorFields[0].name.join("_");
                    document.getElementById(inputFieldName).focus();
                    return;
                    // Errors in the fields
                });
        } else {
            onButtonClick();
        }
    };

    const onHover = () => {
        const hoverData = button.hoverProp;
        setButtonData({
            label: hoverData.label,
            css: {
                backgroundColor: hoverData.css.backgroundColor,
                color: hoverData.css.color,
                fontSize: hoverData.css.fontSize,
            }
        });
        setTooltip({
            visible: hoverData.toolTip ? true : false,
            message: hoverData.toolTip
        })
    };

    const onHoverOut = () => {
        setButtonData({
            label,
            css: {
                display: "flex",
                justifyContent: "center",
                marginBottom: 0,
                textAlign: "center",
            }
        });
        setTooltip({
            visible: false
        })
    }

    return (
        <div className="formBtnGroup" style={{ marginRight: "10px" }}>
            <Tooltip placement="top" open={tooltip.visible} title={<span>{tooltip.message}</span>}>
                <Button
                    danger={type === 'danger'}
                    onMouseOver={button.buttonProp.hover ? onHover : undefined}
                    onMouseOut={onHoverOut}
                    style={buttonData.css}
                    disabled={disabled}
                    type={type === 'danger' ? 'primary' : type}
                    htmlType={"button"}
                    loading={apiLoading}
                    onClick={onClickHandler}
                >
                    {buttonData.label}
                </Button>
            </Tooltip>
        </div>
    );
}

export default FooterButtons;